module.exports = __webpack_public_path__ + "img/7.4de9f270.jpeg";